import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  ModalCloseButton,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { Spacings } from "react-native-ui-lib";
import { WatchedTerminalProvider } from "../../../../components/WatchedTerminalProvider";
import { TerminalSettingsRootParamList } from "../../../../types";
import { useActiveTerminal } from "../../../../utilities/app-state/hooks";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { EditTerminalNameScreen } from "../EditTerminalNameScreen";
import { SelectTerminalPaymentMethodsScreen } from "../SelectTerminalPaymentMethodsScreen";
import { SelectTerminalReceiptTemplateScreen } from "../SelectTerminalReceiptTemplateScreen";
import { SelectTerminalSettingScreen } from "../SelectTerminalSettingScreen";
import { TerminalSettingsLandingScreen } from "../TerminalSettingsLandingScreen";
import { CreatePaymentMethodRootScreen } from "../CreatePaymentMethodRootScreen";

export const TerminalSettingsRootScreen = () => {
  const { terminal } = useActiveTerminal();

  const Drawer = createStackHeaderNavigator<TerminalSettingsRootParamList>();

  // this is a hack to get the theme to update when the user changes the theme
  // because changing the theme Obj does not trigger a refrsh of the component
  const { colors } = useThemeProvider();

  if (!terminal) {
    return (
      <Drawer.Navigator
        screenOptions={{
          title: "",
          cardStyle: { height: "100%", backgroundColor: colors.surface },
          headerLeftContainerStyle: { paddingLeft: Spacings.s5 },
          headerRightContainerStyle: { paddingRight: Spacings.s5 },
          headerTintColor: colors.text,
          headerTitleAlign: "center",
          headerStyle: {
            backgroundColor: colors.surface,
            borderBottomWidth: 1,
            borderBottomColor: colors.borderColor,
          },
        }}
      >
        <Drawer.Group
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <Drawer.Screen
            name="SelectTerminalSettingScreen"
            component={SelectTerminalSettingScreen}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    );
  }

  return (
    <WatchedTerminalProvider terminal={terminal}>
      <Drawer.Navigator
        screenOptions={{
          title: "",
          cardStyle: { height: "100%", backgroundColor: colors.surface },
          headerLeftContainerStyle: { paddingLeft: Spacings.s5 },
          headerRightContainerStyle: { paddingRight: Spacings.s5 },
          headerTintColor: colors.text,
          headerTitleAlign: "center",
          headerStyle: {
            backgroundColor: colors.surface,
            borderBottomWidth: 1,
            borderBottomColor: colors.borderColor,
          },
        }}
      >
        <Drawer.Group
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerLeft: () => <ModalCloseButton type="Back" />,
            title: "",
          }}
        >
          <Drawer.Screen
            name="TerminalSettingsLandingScreen"
            component={TerminalSettingsLandingScreen}
          />
          <Drawer.Screen
            name="SelectTerminalSettingScreen"
            component={SelectTerminalSettingScreen}
          />
          <Drawer.Screen
            name="SelectTerminalReceiptTemplateScreen"
            component={SelectTerminalReceiptTemplateScreen}
            options={{
              title: "Select Receipt Template",
            }}
          />
          <Drawer.Screen
            name="SelectTerminalPaymentMethodsScreen"
            component={SelectTerminalPaymentMethodsScreen}
            options={{
              title: "",
            }}
          />
          <Drawer.Screen
            name="EditTerminalNameScreen"
            component={EditTerminalNameScreen}
            options={{
              title: "Edit Name",
            }}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    </WatchedTerminalProvider>
  );
};
